import { Box } from '@mui/material'
import { WindowApps20Regular } from '@/components/Icon'
import SectionCard from './SectionCard'
import SectionTitleRow from './SectionTitleRow'
import styles from './AppsSection.module.scss'
import { AppsSectionList } from './AppsSectionList.jsx'
import { AppsSectionResizeHandle } from './AppsSectionResizeHandle.jsx'

export default function AppsSectionView(props) {
  const { title, resize, showAll, apps, onAppClick } = props

  return (
    <SectionCard className={styles.appsCard} sx={{ height: resize.appsHeightPx }}>
      <Box className={styles.inner}>
        <SectionTitleRow Icon={WindowApps20Regular} title={title} />
        <AppsSectionList showAll={showAll} apps={apps} onAppClick={onAppClick} />
      </Box>
      <AppsSectionResizeHandle resize={resize} />
    </SectionCard>
  )
}
